import { AuthConfig } from "angular-oauth2-oidc";

export const authCodeFlowConfig: AuthConfig = {
    issuer: '',
    redirectUri: window.location.origin + '/callback',
    postLogoutRedirectUri: window.location.origin + '/callback',
    clientId: '',
    scope: 'openid profile email offline_access',
    responseType: 'code',
    useSilentRefresh: true,
    silentRefreshTimeout: 30,
    oidc: true,
    clearHashAfterLogin: true,
};
